'use client';

import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import _ from 'lodash';
import { redirect } from 'next/navigation';
import { useEffect, useState } from 'react';
import { authApi } from '@/api';
import { Button } from '@/components';
import { googleClientId, pages } from '@/settings';
import { useGlobalStore } from '@/store/provider';
import type { Auth } from '@/types/auth';

// https://blog.logrocket.com/guide-adding-google-login-react-app/

export function SignInWithGoogle({
  afterSignInAction
}: Auth.SignInProps) {
  const {
    user,
    setUser
  } = useGlobalStore(state => state);
  const [isWorking, setIsWorking] = useState(false);
  const [token, setToken] = useState<string | null>(null);
  async function signIn() {
    setIsWorking(true);
    try {
      const {
        data
      } = await authApi.signInWithGoogle({
        token
      });
      setUser(data, null);
    } catch {} finally {
      setIsWorking(false);
    }
  }
  useEffect(() => {
    if (_.isEmpty(user) || !isWorking) return;
    setIsWorking(false);
    if (afterSignInAction) {
      afterSignInAction();
    } else {
      redirect(pages.myProfile.href);
    }
  }, [user]);
  useEffect(() => {
    if (token) {
      signIn();
    }
  }, [token]);
  const BtnLogin = () => {
    const loginAction = useGoogleLogin({
      onSuccess: codeResponse => setToken(codeResponse.access_token)
    });
    return <Button type='button' variant='outline' className='btn-signin' onClick={() => loginAction()} working={isWorking} aria-label='Sign in with Google' aria-busy={isWorking}>
        <img src='/img/google-logo-128.png' className='mr-3 w-5' alt='' aria-hidden='true' />
        Sign in with Google
      </Button>;
  };
  return <GoogleOAuthProvider clientId={googleClientId}>
      <BtnLogin />
    </GoogleOAuthProvider>;
}